module.exports = __webpack_public_path__ + "static/img/culture3.de29000d.jpg";